import * as Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import { ConfigProvider } from "vant";
import "./assets/scss/custom.scss";
import "./assets/scss/style.scss";
import "./assets/scss/template.scss";
import "./assets/scss/color-variables.scss";

const app = Vue.createApp(App);

app.use(store).use(router).use(ElementPlus).use(ConfigProvider).mount("#app");
